// extracted by mini-css-extract-plugin
export default {"modal-close-button":"modal-close-button-_ej7lC0"};